import { Link } from 'react-router-dom';

const IgIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const FbIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const LiIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

export default function Footer() {
  return (
    <footer role="contentinfo">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="logo-row">
              <div className="logo-mark" aria-hidden="true">
                <svg viewBox="0 0 16 16" fill="white">
                  <path d="M3 8.5L7 12.5L13 4" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              Boostio
            </div>
            <p className="footer-desc">
              Slovenská digitálna agentúra. Weby, e-shopy, marketing a automatizácie. Kamil Frajtko.
            </p>
            <div className="footer-socials">
              <a href="https://instagram.com/boostio.sk" target="_blank" rel="noopener" className="social-btn" aria-label="Instagram Boostio">
                <IgIcon />
              </a>
              <a href="https://facebook.com/boostio.sk" target="_blank" rel="noopener" className="social-btn" aria-label="Facebook Boostio">
                <FbIcon />
              </a>
              <a href="https://linkedin.com/in/kamilfrajtko" target="_blank" rel="noopener" className="social-btn" aria-label="LinkedIn Kamil Frajtko">
                <LiIcon />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Služby</h4>
            <ul>
              <li><a href="#sluzby">Weby</a></li>
              <li><a href="#sluzby">E-shopy</a></li>
              <li><a href="#sluzby">Marketing</a></li>
              <li><a href="#sluzby">Sociálne siete</a></li>
              <li><a href="#sluzby">Správa systémov</a></li>
              <li><a href="#sluzby">Interné systémy & CRM</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Projekty</h4>
            <ul>
              <li><a href="https://icfhouse.sk"    target="_blank" rel="noopener">ICF House</a></li>
              <li><a href="https://boxynosice.sk"  target="_blank" rel="noopener">Boxy Nosiče</a></li>
              <li><a href="https://salonsirka.sk"  target="_blank" rel="noopener">Salón Sirka</a></li>
              <li><a href="https://greys.sk"       target="_blank" rel="noopener">MUDr. Sivák</a></li>
              <li><a href="https://petermotyl.sk"  target="_blank" rel="noopener">Peter Motýľ</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Kontakt</h4>
            <ul>
              <li><a href="mailto:info@boostio.sk">info@boostio.sk</a></li>
              <li><a href="#cta-section">Bezplatná analýza</a></li>
              <li><a href="https://boostio.sk">boostio.sk</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal-row">
            <span>© 2026 Boostio | Kamil Frajtko</span>
            <span className="footer-sep">·</span>
            <Link to="/gdpr">Ochrana osobných údajov</Link>
            <span className="footer-sep">·</span>
            <Link to="/podmienky">Obchodné podmienky</Link>
            <span className="footer-sep">·</span>
            <button
              className="footer-cookie-btn"
              onClick={() => window.dispatchEvent(new CustomEvent('boostio:cookie-settings'))}
            >
              Nastavenia cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
